/* eslint-disable max-lines-per-function */
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import mensalidadeService from '../../../services/mensalidades/mensalidadeService';
import { Column } from 'primereact/column';
import Button from '@material-ui/core/Button';
import { Modal } from '@material-ui/core';
import ModalCriarEditarBonificacao from '../modalCriarEditarBonificacao';
import {
    LoadingComponent,
    dataInativacaoBodyTemplate,
    finalVigenciaBodyTemplate,
    inicioVigenciaBodyTemplate,
    statusBodyTemplate,
    tipoCobrancaTemplate
} from '../../../modulos/function/tabelaEdicaoPreco';

const Bonificacao = () => {
    const [bonificacao, setBonificacao] = useState();
    const [openAdicBonificacao, setOpenAdicBonificacao] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [infoEdit, setInfoEdit] = useState();
    const [tipoOperacao, settipoOperacao] = useState('crear');
    const [loadingTabela, setLoadingTabela] = useState(false);

    const handleClose = () => {
        setOpenAdicBonificacao(false);
    };

    const handleOpenModalAbono = () => {
        setOpenAdicBonificacao(true);
        settipoOperacao('criar');
        setInfoEdit(null);
    };

    const handleEditOpenModalAbono = rowData => {
        settipoOperacao('editar');
        setInfoEdit(rowData);
        setOpenAdicBonificacao(true);
    };

    useEffect(() => {
        setLoadingTabela(true);
        mensalidadeService.buscaBonificacaoMensalidades()
            .then(response => {
                setBonificacao(response);
                setLoadingTabela(false);
            })
            .catch(err => {
                setLoadingTabela(false);
                console.error(err);
            });
    }, [loadingUpdate]);

    const ButtonBodyTemplate = rowData => (
        <div className='datatable-editar'>
            <Button variant="text" color="primary" onClick={() => handleEditOpenModalAbono(rowData)}>
                Editar
            </Button>
        </div>
    );

    return (
        <>
            <div>
                <Button
                    variant="contained"
                    className="mt-4 wid"
                    color="primary"
                    onClick={handleOpenModalAbono}
                >
                    Criar Bonificação
                </Button>
            </div>

            <div className="datatable-responsive-demo">
                <h1
                    style={{
                        marginTop: '50px'
                    }}
                >
                    Tabela de Bonificações
                </h1>
                <br />
                <div>
                    <DataTable
                        csvSeparator=";"
                        className="p-datatable-responsive-demo"
                        value={bonificacao}
                        loading={loadingTabela}
                        paginator={true}
                        rowsPerPageOptions={[20, 50]}
                        rows={10}
                    >
                        <Column
                            field="descricao"
                            header="Descricao"
                            bodyStyle={{
                                backgroundColor: '#F5FFFA',
                                height: '60px',
                                textAlign: 'left'
                            }}
                        ></Column>
                        <Column
                            field="dataInicioVigencia"
                            header="Data Inicio Vigência"
                            body={inicioVigenciaBodyTemplate}
                            bodyStyle={{
                                backgroundColor: '#FFFAF0',
                                height: '60px'
                            }}
                        ></Column>
                        <Column
                            field="dataFinalVigencia"
                            header="Data Final Vigência"
                            body={finalVigenciaBodyTemplate}
                            bodyStyle={{ backgroundColor: '#F5FFFA' }}
                        ></Column>
                        <Column
                            field="parcelaBonificacao"
                            header="Parcela Bonificação"
                            bodyStyle={{ backgroundColor: '#FFFAF0' }}
                        ></Column>
                        <Column
                            field="tipoCobranca"
                            header="Tipo Cobrança"
                            body={tipoCobrancaTemplate}
                            bodyStyle={{ backgroundColor: '#F5FFFA' }}
                        ></Column>
                        <Column
                            field="status"
                            header="Status"
                            body={statusBodyTemplate}
                            bodyStyle={{ backgroundColor: '#FFFAF0' }}
                        ></Column>
                        <Column
                            field="dataInativacao"
                            header="Data Inativação"
                            body={dataInativacaoBodyTemplate}
                            bodyStyle={{ backgroundColor: '#F5FFFA' }}
                        ></Column>
                        <Column
                            field=""
                            header="Ação"
                            body={ButtonBodyTemplate}
                            bodyStyle={{
                                textAlign: 'center'
                            }}
                        ></Column>
                    </DataTable>
                    <Modal
                        open={openAdicBonificacao}
                        onClose={handleClose}
                        disableEnforceFocus
                        aria-labelledby="server-modal-title"
                        aria-describedby="server-modal-description"
                    >
                        <div>
                            <ModalCriarEditarBonificacao
                                loadingUpdate={loadingUpdate}
                                handleClose={handleClose}
                                setLoadingUpdate={setLoadingUpdate}
                                tipoOperacao={tipoOperacao}
                                infoEdit={infoEdit || null}
                            />
                        </div>
                    </Modal>
                </div>
                {loadingUpdate &&
                    <LoadingComponent />
                }
            </div>
        </>
    );
};

export default Bonificacao;
